import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=619f7c52&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=619f7c52&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f7c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('619f7c52')) {
      api.createRecord('619f7c52', component.options)
    } else {
      api.reload('619f7c52', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=619f7c52&scoped=true", function () {
      api.rerender('619f7c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/network_construction/form/detail.vue"
export default component.exports